
<script>
import { h } from 'vue';
import themesMixin from '../../mixins/themes.js';
import { getFirstElement } from '../../utils/helpers.js';

/**
 * Компонент для группирования кнопок SbsButton.
 */
export default {
    name: 'SbsButtonGroup',
    mixins: [themesMixin],
    provide() {
        return {
            buttonGroupComponent: this,
        };
    },
    computed: {
        buttonGroupClasses() {
            return [
                'sbs-button-group',
                ...this.themeClasses,
                {
                    disabled: this.disabled,
                },
            ];
        },
    },
    methods: {
        createSeparator() {
            /** @slot Слот для сепаратора */
            const separatorSlot = getFirstElement(this.$slots.separator && this.$slots.separator());

            if (separatorSlot) return separatorSlot;

            return h(
                'span',
                { class: 'sbs-button-group__separator' },
            );
        },
    },
    props: {
        /**
         * Отключает взаимодействие с компонентом
         */
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    render() {
        /** @slot Слот по-умолчанию */
        const defaultSlot = this.$slots.default && this.$slots.default();

        if (!defaultSlot?.length) return;

        const buttonGroupContent = [];
        const separator = this.createSeparator();

        defaultSlot.forEach((item, i) => {
            const element = [item];

            if (i < defaultSlot.length - 1) element.push(separator);

            buttonGroupContent.push(...element);
        });

        return h(
            'div',
            { class: this.buttonGroupClasses },
            buttonGroupContent,
        );
    },
};
</script>

<style lang="scss">
.sbs-button-group {
    position: relative;
    display: inline-flex;

    &.disabled {
        cursor: not-allowed;
        user-select: none;

        & > * {
            pointer-events: none;
        }
    }

    &__separator {
        width: 1px;
        margin-top: 10px;
        margin-bottom: 10px;
        background-color: $gray;
    }
}
</style>
